import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { dispatch } from "../index";

import utils from "../../utils/utils";

const API = {};
const Auth = {};

const apiName = "clearMindsHypnotherapy";

const path = "/manager";

const initialState = {
  error: null,
  usersS1: [],
  usersS2: [],
  followers: [],
  friendRequests: [],
  friends: [],
  gallery: [],
  posts: [],
  detailCards: [],
  simpleCards: [],
  profileCards: [],
  totalPages: 1,
  loading: false,
  limit: 10,
  currentPage: 1,
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    startLoading(state, action) {
      state.loading = true;
    },
    stopLoading(state, action) {
      state.loading = false;
    },
    getUsersListStyle1Success(state, action) {
      state.usersS1 = action.payload;
      state.loading = false;
    },
    setCurrentPage(state, action) {
      console.log(action.payload);
      state.currentPage = action.payload;
    },

    // Add User
    addUser(state, action) {
      const users = state.usersS1;
      state.loading = false;
    },
    disableAdmin(state, action) {
      const oldData = action.payload;
      const uData = state.usersS1;
      let i = -1;
      uData.forEach((u, index) => {
        if (u.Username === oldData.Username) {
          i = index;
        }
      });
      const newData = {
        Attributes: oldData.Attributes,
        Enabled: false,
        UserCreateDate: oldData.UserCreateDate,
        UserState: oldData.UserStatus,
        UserLastModifiedDate: oldData.UserLastModifiedDate,
        Username: oldData.Username,
      };

      uData[i] = newData;
      state.usersS1 = uData;
      state.loading = false;
    },
    enableAdmin(state, action) {
      const oldData = action.payload;
      const uData = state.usersS1;
      let i = -1;
      uData.forEach((u, index) => {
        if (u.Username === oldData.Username) {
          i = index;
        }
      });
      const newData = {
        Attributes: oldData.Attributes,
        Enabled: true,
        UserCreateDate: oldData.UserCreateDate,
        UserState: oldData.UserStatus,
        UserLastModifiedDate: oldData.UserLastModifiedDate,
        Username: oldData.Username,
      };

      uData[i] = newData;
      state.usersS1 = uData;
      state.loading = false;
    },

    editUser(state, action) {
      state.loading = false;
    },

    getUsersListStyle2Success(state, action) {
      state.usersS2 = action.payload;
    },

    getFollowersSuccess(state, action) {
      state.followers = action.payload;
    },

    filterFollowersSuccess(state, action) {
      state.followers = action.payload;
    },

    getFriendRequestsSuccess(state, action) {
      state.friendRequests = action.payload;
    },

    filterFriendRequestsSuccess(state, action) {
      state.friendRequests = action.payload;
    },

    getFriendsSuccess(state, action) {
      state.friends = action.payload;
    },

    filterFriendsSuccess(state, action) {
      state.friends = action.payload;
    },

    getGallerySuccess(state, action) {
      state.gallery = action.payload;
    },

    getPostsSuccess(state, action) {
      state.posts = action.payload;
    },

    editCommentSuccess(state, action) {
      state.posts = action.payload;
    },

    addCommentSuccess(state, action) {
      state.posts = action.payload;
    },

    addReplySuccess(state, action) {
      state.posts = action.payload;
    },

    likePostSuccess(state, action) {
      state.posts = action.payload;
    },

    likeCommentSuccess(state, action) {
      state.posts = action.payload;
    },

    likeReplySuccess(state, action) {
      state.posts = action.payload;
    },

    getDetailCardsSuccess(state, action) {
      state.detailCards = action.payload;
    },

    filterDetailCardsSuccess(state, action) {
      state.detailCards = action.payload;
    },

    getSimpleCardsSuccess(state, action) {
      state.simpleCards = action.payload;
    },

    filterSimpleCardsSuccess(state, action) {
      state.simpleCards = action.payload;
    },

    getProfileCardsSuccess(state, action) {
      state.profileCards = action.payload;
    },

    filterProfileCardsSuccess(state, action) {
      state.profileCards = action.payload;
    },
  },
});

export default slice.reducer;

export function startLoading() {
  return async () => {
    dispatch(slice.actions.startLoading());
  };
}

export function stopLoading() {
  return async () => {
    dispatch(slice.actions.stopLoading());
  };
}

let nextToken;

// Nabuz admins are determined purely by the NABUZ_ADMIN permission flag.
// The backend list-admins endpoint is super-admin only and returns
// [{ id, email, is_admin, is_super_admin }].
const NABUZ_ADMIN_FLAG = 1 << 2; // 4
const NABUZ_SUPER_ADMIN_FLAG = 1 << 3; // 8

export function getAdmins() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading());
      const response = await axios.get("/uni/list-admins");
      dispatch(slice.actions.getUsersListStyle1Success(response.data));
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.stopLoading());
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editAdmin(id, data, navigate) {
  return async () => {
    try {
      const token = (await Auth.currentSession()).getIdToken().getJwtToken();

      const myInit = {
        body: data,
        headers: {
          Authorization: token,
        },
      };

      API.put(apiName, path, myInit)
        .then((res) => {
          dispatch(slice.actions.editUser());
          navigate("/");
        })
        .catch((error) => {
          console.log(error);
          dispatch(slice.actions.hasError(error));
        });
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editUser(id, data, navigate) {
  return async () => {
    try {
      const token = (await Auth.currentSession()).getIdToken().getJwtToken();

      const myInit = {
        body: data,
        headers: {
          Authorization: token,
        },
      };

      API.put(apiName, path, myInit)
        .then((res) => {
          dispatch(slice.actions.editUser());
          navigate("/");
        })
        .catch((error) => {
          console.log(error);
          dispatch(slice.actions.hasError(error));
        });
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Toggle the super-admin flag on an existing admin. Backend allows this only for
// super admins (and the admin/super-admin bits are super-admin-gated).
export function setAdminSuperAdmin(user, isSuper) {
  return async () => {
    try {
      dispatch(slice.actions.startLoading());
      await axios.post("/uni/set_user_permission_flags", {
        user_id: user.id,
        mask: NABUZ_SUPER_ADMIN_FLAG,
        flags: isSuper ? NABUZ_SUPER_ADMIN_FLAG : 0,
      });
      dispatch(getAdmins());
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message;
      if (msg) utils.snackBarMsg(dispatch, msg);
      dispatch(getAdmins());
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Remove a user as admin: clears BOTH the admin and super-admin flags so they
// drop out of the admins list (other permission flags are preserved).
export function removeAdmin(user) {
  return async () => {
    try {
      dispatch(slice.actions.startLoading());
      await axios.post("/uni/set_user_permission_flags", {
        user_id: user.id,
        mask: NABUZ_ADMIN_FLAG | NABUZ_SUPER_ADMIN_FLAG,
        flags: 0,
      });
      dispatch(getAdmins());
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message;
      if (msg) utils.snackBarMsg(dispatch, msg);
      dispatch(getAdmins());
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Add an EXISTING user (by email) as an admin, optionally as super-admin.
// Sets the NABUZ_ADMIN flag (+ super-admin if requested) on the backend.
export function addAdmin(data, navigate) {
  return async () => {
    try {
      await axios.post("/uni/add-admin-by-email", {
        email: data.email,
        super_admin: !!data.super_admin,
      });
      dispatch(stopLoading());
      navigate("/admins");
    } catch (error) {
      dispatch(stopLoading());
      const msg = error?.response?.data?.message || error?.message;
      if (msg) {
        utils.snackBarMsg(dispatch, msg);
      }
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Create a pre-verified app user with an admin-supplied email + password.
// Hits the admin-gated /auth/create_verified_user endpoint, which skips the
// email-verification round-trip and marks the account verified, so the
// supplied credentials can be handed straight to the person to log in on the app.
export function addUser(data, navigate) {
  return async () => {
    try {
      await axios.post("/auth/create_verified_user", {
        email: data.email,
        password: data.password,
        name: data.name || "",
      });
      dispatch(slice.actions.stopLoading());
      utils.snackBarMsg(
        dispatch,
        "User created. Share the email and password so they can log in on the app.",
        "success"
      );
      navigate("/users");
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message;
      if (msg) {
        utils.snackBarMsg(dispatch, msg);
      }
      dispatch(slice.actions.stopLoading());
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCurrentPage(page) {
  return async () => {
    dispatch(slice.actions.setCurrentPage(page));
  };
}

export function getUsersListStyle2() {
  return async () => {
    try {
      const response = await axios.get("/user-list/s2/list");
      dispatch(slice.actions.getUsersListStyle2Success(response.data.users_s2));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFollowers() {
  return async () => {
    try {
      const response = await axios.get("/followers/list");
      dispatch(slice.actions.getFollowersSuccess(response.data.followers));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function filterFollowers(key) {
  return async () => {
    try {
      const response = await axios.post("/followers/filter", { key });
      dispatch(slice.actions.filterFollowersSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFriendRequests() {
  return async () => {
    try {
      const response = await axios.get("/friend-request/list");
      dispatch(slice.actions.getFriendRequestsSuccess(response.data.friends));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function filterFriendRequests(key) {
  return async () => {
    try {
      const response = await axios.post("/friend-request/filter", { key });
      dispatch(
        slice.actions.filterFriendRequestsSuccess(response.data.results)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFriends() {
  return async () => {
    try {
      const response = await axios.get("/friends/list");
      dispatch(slice.actions.getFriendsSuccess(response.data.friends));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function filterFriends(key) {
  return async () => {
    try {
      const response = await axios.post("/friends/filter", { key });
      dispatch(slice.actions.filterFriendsSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGallery() {
  return async () => {
    try {
      const response = await axios.get("/gallery/list");
      dispatch(slice.actions.getGallerySuccess(response.data.gallery));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPosts() {
  return async () => {
    try {
      const response = await axios.get("/posts/list");
      dispatch(slice.actions.getPostsSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editComment(key, id) {
  return async () => {
    try {
      const response = await axios.post("/posts/editComment", { key, id });
      dispatch(slice.actions.editCommentSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addComment(postId, comment) {
  return async () => {
    try {
      const response = await axios.post("/comments/add", { postId, comment });
      dispatch(slice.actions.addCommentSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addReply(postId, commentId, reply) {
  return async () => {
    try {
      const response = await axios.post("/replies/add", {
        postId,
        commentId,
        reply,
      });
      dispatch(slice.actions.addReplySuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function likePost(postId) {
  return async () => {
    try {
      const response = await axios.post("/posts/list/like", { postId });
      dispatch(slice.actions.likePostSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function likeComment(postId, commentId) {
  return async () => {
    try {
      const response = await axios.post("/comments/list/like", {
        postId,
        commentId,
      });
      dispatch(slice.actions.likeCommentSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function likeReply(postId, commentId, replayId) {
  return async () => {
    try {
      const response = await axios.post("/replies/list/like", {
        postId,
        commentId,
        replayId,
      });
      dispatch(slice.actions.likeReplySuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getDetailCards() {
  return async () => {
    try {
      const response = await axios.get("/details-card/list");
      dispatch(slice.actions.getDetailCardsSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function filterDetailCards(key) {
  return async () => {
    try {
      const response = await axios.post("/details-card/filter", { key });
      dispatch(slice.actions.filterDetailCardsSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSimpleCards() {
  return async () => {
    try {
      const response = await axios.get("/simple-card/list");
      dispatch(slice.actions.getSimpleCardsSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function filterSimpleCards(key) {
  return async () => {
    try {
      const response = await axios.post("/simple-card/filter", { key });
      dispatch(slice.actions.filterSimpleCardsSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getProfileCards() {
  return async () => {
    try {
      const response = await axios.get("/profile-card/list");
      dispatch(slice.actions.getProfileCardsSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function filterProfileCards(key) {
  return async () => {
    try {
      const response = await axios.post("/profile-card/filter", { key });
      dispatch(slice.actions.filterProfileCardsSuccess(response.data.results));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
